// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"862dc499","928":"4c929e0d"}[chunkId] + ".chunk.js";
};